import { ListingMapMetaData } from "@/services/apiTypes";
import { formatPrice } from "@/utils/formatPrice";
import Image from "next/image";
import { useState } from "react";

const GetListingMapMetaData = ({ data }: { data: ListingMapMetaData }) => {
  const [isPressed, setIsPressed] = useState(false);

  return (
    <a
      href={`/properties/${data.areaSlug}/${data.id}`}
      onMouseEnter={() => setIsPressed(true)}
      onMouseUp={() => setIsPressed(false)}
      onMouseLeave={() => setIsPressed(false)}
      className={`block rounded-xl transition-all py-[10px] ${
        isPressed ? "scale-95 opacity-80" : ""
      }`}
    >
      <div className="flex px-[10px] py-[5px] gap-5 font-sans">
        {/* Since we cant use next image inside google maps info window */}
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img
          src={data.pictures}
          alt="map icon"
          width={109}
          height={72}
          style={{ objectFit: "cover", borderRadius: 15 }}
        />
        <div className="flex flex-col justify-between  ">
          <div className="flex flex-col text-landing-blue font-outfit font-semibold ">
            <p className="text-base ">{data.short_title}</p>
            <p className="text-lg font-semibold">{formatPrice(data.pcm)} pcm</p>
          </div>
          <div className="flex gap-[24px] ">
            <div className="flex items-end ">
              <div className="relative">
                <Image
                  src={"/icons/bedroom.svg"}
                  alt={"bedroom"}
                  width={25}
                  height={16}
                  objectFit="contain"
                  priority
                />
              </div>
              <p className="flex">{data.bedrooms}</p>
            </div>

            <div className="flex items-end">
              <div className="relative">
                <Image
                  src={"/icons/bathroom.svg"}
                  alt={"bathroom"}
                  width={25}
                  height={16}
                  objectFit="contain"
                  priority
                />
              </div>
              <p>{data.bathrooms}</p>
            </div>

            <div className="flex items-end ">
              <div className="relative">
                <Image
                  src={"/icons/living-room.svg"}
                  alt={"living room"}
                  width={24}
                  height={13}
                  objectFit="contain"
                  priority
                />
              </div>
              <p>{data.living_rooms}</p>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default GetListingMapMetaData;
